module.exports = __webpack_public_path__ + "static/media/app-store-ios.f86550d5.svg";